import { InfobipStyleSender } from "@/components/communications/InfobipStyleSender";
import { AutomationBuilder } from "@/components/communications/AutomationBuilder";
import { CampaignBuilder } from "@/components/communications/CampaignBuilder";
import { CampaignList } from "@/components/communications/CampaignList";
import { TemplateManager } from "@/components/communications/TemplateManager";
import { CampaignAnalytics } from "@/components/communications/CampaignAnalytics";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Communications = () => {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Communications & Campaigns</h2>
        <p className="text-muted-foreground">
          Create campaigns, send messages, and automate communications
        </p>
      </div>

      <Tabs defaultValue="campaigns" className="w-full">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="campaigns">Campaigns</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="send">Quick Send</TabsTrigger>
          <TabsTrigger value="automation">Automation</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="campaigns" className="space-y-6">
          <CampaignBuilder />
          <CampaignList />
        </TabsContent>

        <TabsContent value="templates" className="space-y-6">
          <TemplateManager />
        </TabsContent>

        <TabsContent value="send" className="space-y-6">
          <InfobipStyleSender />
        </TabsContent>

        <TabsContent value="automation" className="space-y-6">
          <AutomationBuilder />
        </TabsContent>

        <TabsContent value="analytics" className="space-y-6">
          <CampaignAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Communications;
